import {useMutation} from "@tanstack/react-query";

import {addRepresentativeContactMutationOptions} from "./add-representative-contact.mutation-options";

export function useAddRepresentativeContact(representativeId: string) {
  return useMutation(addRepresentativeContactMutationOptions(representativeId));
}
